import { render, staticRenderFns } from "./extend-booking-date-picker.vue?vue&type=template&id=245de3ce&scoped=true&"
import script from "./extend-booking-date-picker.vue?vue&type=script&lang=js&"
export * from "./extend-booking-date-picker.vue?vue&type=script&lang=js&"
import style0 from "./extend-booking-date-picker.vue?vue&type=style&index=0&id=245de3ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245de3ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VForm,VMenu,VTextField})
